import * as z from "zod/v4";

const ToteWorkOrder_ = z.object({
  workOrderId: z.string(),
  flowName: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  currentStepTitle: z.string().nullable(),
  status: z.string(),
});
export const ToteWorkOrder: z.ZodType<ToteWorkOrder> = ToteWorkOrder_;
export interface ToteWorkOrder extends z.infer<typeof ToteWorkOrder_> {}

export const lookupWorkOrdersByTote = {
  name: "lookupWorkOrdersByTote" as const,
  input: z.object({ barcode: z.string() }),
  output: z.object({
    workOrders: z.array(ToteWorkOrder),
    toteName: z.string().nullable(),
  }),
};
